export default __webpack_public_path__ + "static/media/card_top.94ecd8c3.png";